module.exports = __webpack_public_path__ + "img/cx_diabetes.f268d2a5.webp";